<template>
    <div class="modal fade" 
        :class="modalPosition" 
        :id="modalID" tabindex="-1" 
        :aria-labelledby="theModalLabel" 
        aria-hidden="true"
        @click.self="$emit('closeModal')">
        <div class="np-base-dialog modal-dialog modal-dialog-centered w-100" :class="modalSize">
            <div class="modal-content shadow">
                <div class="modal-header border-0 p-4 pb-2">
                    <span class="col-sm-8 d-flex align-middle">
                        <slot name="header-left"></slot>
                    </span>
                    <div class="d-flex justify-content-end flex-grow-1">
                        <button type="button" class="np-btn np-outline" data-bs-dismiss="modal" aria-label="Close">
                            <svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
                        </button>
                        <slot name="header-right"></slot>
                    </div>
                </div>                
                
                <slot name="body"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
export default {
    props: {
        modalID: {
            type: String,
            required: true
        },
        modalSize: {
            type: String,
            default: ''  // или любой другой дефолт
        },
        modalPosition: {
            type: String,
            default: ''  // или любой другой дефолт
        }
    },    
    data() {
        return {
            theModal: null,
            theModalLabel: null
        }
    },
    mounted: function () {
        var IdModal = '#' + this.$props.modalID
        this.theModalLabel = this.modalID + "Label"

        this.theModal = new Modal(IdModal, {backdrop: true})
    },
    methods: {
        shows() {
            this.theModal.show()
        },
        hide() {
            this.theModal.hide()
        }
    }
}
</script>

<style>
    .modal {
        backdrop-filter: blur(5px);
    }
</style>